import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatComponent } from 'src/app/model/cat-component.model';

@Injectable({
    providedIn: 'root'
})

export class CatComponentService {

    private url: string;
    private sideBarComponents: any;
    private elementsComponent: any;

    ////////////////
    constructor(private http: HttpClient) {
        this.url = environment.services_url;
    }

    getComponents() {
        if (this.sideBarComponents == null) {
            this.sideBarComponents = this.getAll();
        }
        return this.sideBarComponents;
    }

    getElementsForComponent() {
        if (this.elementsComponent == null) {
            this.elementsComponent = this.getAllComponents();
        }
        return this.elementsComponent;
    }

    // Método para limpiar el caché
    clearCache() {
        this.sideBarComponents = null;
        this.elementsComponent = null;
    }

    // Método para refrescar componentes (limpia caché y vuelve a cargar)
    refreshComponents() {
        this.clearCache();
        return this.getComponents();
    }

    private getAllComponents = () => {
        return this.http.get(`${this.url}/CatComponent/ListElementsForComponent`)
            .pipe(
                map((resp: any) => resp)
            );
    }

    private getAll = () => {
        return this.http.get(`${this.url}/CatComponent/List`)
            .pipe(
                map((resp: any) => resp)
            );
    }

    save = (component: CatComponent) => {
        return this.http.post(`${this.url}/CatComponent/SaveUpdate`, component)
            .pipe(map((resp: any) => resp));
    }

    update = (component: CatComponent) => {
        return this.http.post(`${this.url}/CatComponent/SaveUpdate/${component.componentId}`, component)
            .pipe(map((resp: any) => resp));
    }

    delete = (componentId: string) => {
        return this.http.delete(`${this.url}/CatComponent/Delete/${componentId}`)
            .pipe(map((resp: any) => resp));
    }

}